export const en = {
  reported: 'Reported',
  by: 'by',
  reportedBy: 'REPORTED BY:',
  dateReported: 'DATE REPORTED:'
};

export type Translations = typeof en;
